


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getModules } from '@/utils/module';
import { Debounced } from '@/utils/debounced';

type IModuleInfo = IModule.IResponse.IModuleInfo;

@Component
export default class SelectModule extends Vue {
  private moduleOptions: IModuleInfo[] = [];
  private fetching: boolean = false;
  private debouncedFetchModule: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchModules, 1000); // 节流函数
  // 请求模块数据
  private searchModules(searchVal: string) {
    this.fetching = true;
    getModules({
      title: searchVal,
    }).then((res) => {
      this.fetching = false;
      this.moduleOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 触发搜索模块方法
  private fetchModules(searchVal: string) {
    this.debouncedFetchModule(searchVal);
  }
  // 处理选项改变
  private handleChange(value?: string) {
    const moduleInfo = this.moduleOptions.find((option) => option.id === value) || null;
    this.$emit('change', moduleInfo);
  }
}
